// extracted by mini-css-extract-plugin
export default {"selectGroup":"select_selectGroup__AyXHS"};